import { Button, Dialog, DialogActions, DialogContent, DialogTitle, makeStyles, Typography } from '@mui/material';
import React from 'react'

// const useStyles = makeStyles(theme => ({
//     dialog: {
//         padding: theme.spacing(2),
//         position: 'absolute',
//         top: theme.spacing(5)
//     }
// }));

const ConfirmDialog = (props) => {
    const { confirmDialog, setConfirmDialog } = props;
    // const classes = useStyles()
  return (
    <Dialog open={confirmDialog.isOpen} >
      <DialogTitle>

      </DialogTitle>
      <DialogContent sx={{textAlign: 'center'}}>
        <Typography variant='h6'> {confirmDialog.title} </Typography>
        <Typography variant='subtitle2'> {confirmDialog.subTitle} </Typography>
      </DialogContent>
      <DialogActions>
        <Button 
            variant="contained"
            onClick={()=>setConfirmDialog({...confirmDialog, isOpen: false})} >
            No
        </Button>
        <Button 
            variant="contained" 
            color="error"
            onClick={confirmDialog.onConfirm}>
            Yes
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDialog
